module.exports = __webpack_public_path__ + "img/show-content.ae23bb3c.png";